import { IEvent, IHost } from "@Interfaces";
import { getEventHeaderTitle } from "@Modules/eventPage/utils/getEventHeaderTitle";
import { ITemplate } from "@Templates/ITemplate";
import { DEFAULT_PROFILE_PIC_SRC } from "repoV2/utils/common/assets/assets";
import { IModalTypes, IUseModal, MODAL_TYPES, pluralise } from "@Utils";
import { getSortedSocialLinks } from "@Utils/host";
import { getQueryParam } from "repoV2/utils/urls&routing/urlParams";
import { URL_SEARCH_PARAMS } from "repoV2/features/Common/modules/URLsNRouting/URLsNRouting.constants";
import { IAboutCreator } from "./IAboutCreator";

export const getAboutCreatorProps = ({
    hostData,
    eventData,
    dynamicLink,
    showGuestInfoModal,
    handleOpenModal,
}: {
    hostData: IHost.IHostData;
    eventData: IEvent.IEventData;
    dynamicLink?: string;
    showGuestInfoModal: () => void;
    handleOpenModal: (
        modalTypeArg: IModalTypes,
        openModalArgs?: IUseModal.IOpenModalProps
    ) => void;
}): IAboutCreator.IProps => {
    const reviewCount = eventData.reviews?.length || 0;

    const socialInfo = hostData?.social_info || {};

    const socialLinks: ITemplate.ISocialIconsProps["socialLinks"] =
        getSortedSocialLinks(socialInfo);

    return {
        hideComponent: eventData?.metadata?.hide_creator_detail,
        hideCreatorHeader: hostData?.hide_creator_header_event_page,
        creatorImg: hostData?.profile_pic || DEFAULT_PROFILE_PIC_SRC,
        meetYourCreatorTitle:
            (hostData?.meet_creator || "Meet Your Creator,  ") +
            hostData?.title,
        creatorShortDescription: hostData?.short_description,
        creatorStats: [
            {
                count: reviewCount,
                text: pluralise("Review", reviewCount),
            },
            { count: hostData?.rating, text: "Rating" },
        ],
        minifyCreatorDescription:
            eventData?.metadata?.creator_desc_minify_length ?? true, // true if not defined
        creatorDescription: hostData?.description || "",
        socialLinks,
        hideCheckoutAllOfferingsCta: !!(
            eventData?.metadata?.is_demo ||
            dynamicLink ||
            getQueryParam(URL_SEARCH_PARAMS.HIDE_WEBSITE_CTA)
        ),
        checkoutAllOfferingsCtaText:
            hostData?.all_offerings_cta_text || "Visit Website",
        contactCreatorCtaText:
            hostData?.contact_creator_cta_text || "Contact Creator",
        onContactCreatorCtaClick: showGuestInfoModal,
        hideShareEventCtaText: hostData?.hide_share_event_cta,
        shareEventCtaText:
            hostData?.share_event_cta_text ||
            `Share this ${getEventHeaderTitle({ eventData })}`,
        onShareEventCtaClick: () => {
            handleOpenModal(MODAL_TYPES.Share);
        },
    };
};
